// English language pack modular import
import aggrid from './aggrid'
import rateShare from './rate-share'
import rateSubscribe from './rate-subscribe'
import app from './app'
import common from './common'
import menu from './menu'
import company from './company'
import orders from './orders'
import billing from './billing'
import users from './users'
import error from './error'
import ports from './ports'
import saas from './saas'
import cardRateQuery from './card-rate-query'
import ecommerceCarrierRates from './ecommerce-carrier-rates'
import controlTower from './controlTower'
import auth from './auth'
import advancedFilter from './advanced-filter'
import components from './components'
import staff from './staff'
import permission from './permission'
import template from './template'
import config from './config'
import route from './route'
import routeV2 from './route-v2'
import profile from './profile'
import enterpriseProfile from './enterpriseProfile'
import userManager from './userManager'
import calculationUnit from './calculation-unit'
import carrier from './carrier'
import charge from './charge'
import chinaDivision from './china-division'
import container from './container'
import countryRegion from './country-region'
import currency from './currency'
import exchangeRate from './exchange-rate'
import overseasWarehouse from './overseas-warehouse'
import packageUnit from './package-unit'
import cargoType from './cargo-type'
import shipAgent from './ship-agent'
import shipData from './ship-data'
import terminal from './terminal'
import tradeTerms from './trade-terms'
import transportTerms from './transport-terms'
import zipcode from './zipcode'
import shipping from './shipping'
import personalization from './personalization'
import companyNews from './companyNews'
import taskManagement from './task-management'
import supplierQuotationConfig from './supplier-quotation-config'
import businessManager from './business-manager'
import increaseRules from './increase-rules'
import salesPricing from './sales-pricing'
import rolePermission from './role-permission'
import enterpriseApiConfig from './enterprise-api-config'
import home from './home'
import appCenter from './app-center'
import nodeManagement from './node-management'
import approvalProcess from './approval-process'
import apiSync from './api-sync'
import sales from './sales'
import alertCenter from './alert-center'
import biAnalytics from './bi-analytics'
import quotation from './quotation'
import trackingConfig from './tracking-config'
import order from './order'
import bellMessage from './bell-message'
import tools from './tools'
import apiCenter from './api-center'
import transportPlan from './transport-plan'
import transportConsignment from './transport-consignment'
import documentControl from './document-control'
import waybill from './waybill'
import productMaterialData from './product-material-data'
import carrierAccount from './carrier-account'
import bidding from './bidding'
import businessException from './business-exception'
import supplierContract from './supplier-contract'
import reportCenter from './report-center'

export default {
  app,
  common,
  menu,
  company,
  orders,
  billing,
  users,
  error,
  ports,
  saas,
  cardRateQuery,
  ecommerceCarrierRates,
  controlTower,
  auth,
  advancedFilter,
  components,
  enterpriseApiConfig,
  staff,
  permission,
  template,
  config,
  route,
  routeV2,
  profile,
  enterpriseProfile,
  userManager,
  calculationUnit,
  carrier,
  charge,
  chinaDivision,
  container,
  countryRegion,
  currency,
  exchangeRate,
  overseasWarehouse,
  packageUnit,
  cargoType,
  shipAgent,
  shipData,
  terminal,
  tradeTerms,
  transportTerms,
  zipcode,
  shipping,
  personalization,
  companyNews,
  taskManagement,
  supplierQuotationConfig,
  businessManager,
  increaseRules,
  salesPricing,
  rolePermission,
  home,
  appCenter,
  nodeManagement,
  approvalProcess,
  apiSync,
  sales,
  alertCenter,
  biAnalytics,
  quotation,
  trackingConfig,
  order,
  bellMessage,
  tools,
  apiCenter,
  transportPlan,
  transportConsignment,
  documentControl,
  waybill,
  productMaterialData,
  carrierAccount,
  aggrid,
  rateShare,
  rateSubscribe,
  bidding,
  businessException,
  supplierContract,
  reportCenter
}
